function* combinationN<T = unknown>(
  array: T[],
  n: number
): IterableIterator<T[]> {
  if (n === 1) {
    for (const a of array) {
      yield [a];
    }
    return;
  }

  for (let i = 0; i <= array.length - n; i++) {
    for (const c of combinationN(array.slice(i + 1), n - 1)) {
      yield [array[i], ...c];
    }
  }
}

export function* generateAllCombinations<T = unknown>(
  array: T[],
  maxComboLength?: number
) {
  for (let i = 1; i <= (maxComboLength ?? array.length); i++) {
    yield* combinationN(array, i);
  }
}
